import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input, Button, Modal, Divider } from 'antd';
import { ReloadOutlined, SyncOutlined } from '@ant-design/icons';
import { filter, isEmpty } from 'lodash';

import * as constants from '../constants';
import LocalUserRoles from './LocalUserRoles';
import LocalUserRoleDetailsCompanies from './LocalUserRoleDetailsCompanies';
import {
    loadUsersWithLocalAppRights,
    setSelectedLocalAppUser,
    addSelectedUserToLocalList,
    loadLocalEntities,
    clearServerRightsCache
} from '../actions';

import core from '../../core';
import globalappstate from '../../globalappstate';
import companies from '../../companies';
import common from '../../../common';
import uistate from '../../uistate';

const { GenericTable } = core;
const { UsersTable } = globalappstate;


class LocalUsersTable extends Component {

    UNSAFE_componentWillMount() {
        this.props.loadUsersWithLocalAppRights(false);
        this.props.loadCompaniesHierarchy();
        this.props.loadLocalEntities();
    }

    state = {
        filteredInfo: null,
        sortedInfo: null,
        filtertext: '',
        selectuser_visible: false,
        newuser_id: 0
    };
    setFilterText = (txt) => {
        this.setState({
            filtertext: txt.toLowerCase(),
        });
    }
    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }
    selectClicked = (id) => {
        this.props.setSelectedLocalAppUser(id);
    }
    addClicked = (e) => {
        this.setState({
            selectuser_visible: true,
        });
    }
    refreshUsers = () => {
        this.props.loadUsersWithLocalAppRights(true);
    }
    clearRightsCache = () => {
        this.props.clearServerRightsCache();
    }

    handleOk = (e) => {
        this.props.addSelectedUserToLocalList(this.state.newuser_id)
        this.setState({
            selectuser_visible: false,
            newuser_id: 0,
        });
    }
    handleCancel = (e) => {
        this.setState({
            selectuser_visible: false,
        });
    }
    selectedNewUserChanged = (id) => {
        this.setState({
            newuser_id: id,
        });
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LocalUsersTable', key);
    }

    render() {
        let { sortedInfo, filteredInfo, filtertext } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const columns = [{
            title: this.label('Id'),
            dataIndex: 'idUser',
            key: 'idUser',
            sorter: (a, b) => a.idUser - b.idUser,
            sortOrder: sortedInfo.columnKey === 'idUser' && sortedInfo.order,
        }, {
            title: this.label('Name'),
            dataIndex: 'displayname',
            key: 'displayname',
            sorter: (a, b) => ('' + a.displayname).localeCompare(b.displayname),
            sortOrder: sortedInfo.columnKey === 'displayname' && sortedInfo.order,
        }];

        const filteredUsers = filter(this.props.localAppUsers, function (o) {
            return o.displayname.toLowerCase().includes(filtertext);
        });
        return (
            <div>

                <Button type="primary" icon={<ReloadOutlined />} style={{ margin: 7 }} onClick={this.refreshUsers} />
                <Input.Search
                    placeholder={this.label('SearchText')}
                    onSearch={value => this.setFilterText(value)}
                    style={{ width: 300, margin: 15 }} />
                <Button icon={<SyncOutlined />} title="Clear rights cache" style={{ margin: 7, marginLeft: 250 }} onClick={this.clearRightsCache} />
                <br />
                <Row>
                    <Col span={8} >
                        <Divider>{this.label('AppUsers')}</Divider>
                        <GenericTable columns={columns} data={filteredUsers} keyfield='idUser' itemName={this.label('User')}
                            onAdd={this.addClicked} onSelect={this.selectClicked} pageSize={20} />
                        <Divider>{this.label('Roles')}</Divider>
                        <LocalUserRoles />
                    </Col>
                    <Col span={16} style={{ paddingLeft: 20 }}>
                        <LocalUserRoleDetailsCompanies />
                    </Col>
                </Row>
                <Modal width='80%'
                    title={this.label('SelectUser')}
                    open={this.state.selectuser_visible}
                    onOk={this.handleOk} onCancel={this.handleCancel}>
                    <UsersTable onSelect={this.selectedNewUserChanged} pagesize={10} />
                </Modal>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        localAppUsers: state[constants.NAME].localAppUsers,
        selectedUserRoleDetails: state[constants.NAME].selectedUserRoleDetails,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps, {
    loadUsersWithLocalAppRights,
    setSelectedLocalAppUser,
    addSelectedUserToLocalList,
    loadCompaniesHierarchy: companies.actions.loadCompaniesHierarchy,
    loadLocalEntities,
    clearServerRightsCache
})(LocalUsersTable);  